import TransferOrderController from './transferorder.controller';
import TransferOrderListController from './transferorder.list.controller';

/**
 * this is the controller to edit a transport order
 **/
export default class TransferOrderEditController extends TransferOrderController {
	/**
	 * define required services here, think of the defined services inside the constructor of the superclass
	 * @param {function} - $injector to inject all services
	 **/
	constructor($injector, $scope) {
		super($injector);
		this.$rootScope = $injector.get('$rootScope');
		this.$mdDialog = $injector.get('$mdDialog');
		this.TransferOrderService = $injector.get('TransferOrderService');
        this.LocationService = $injector.get('LocationService');
        this.DaisyValidationService = $injector.get('DaisyValidationService');
		this.TimeService = $injector.get('TimeService');
		this.moment = $injector.get('moment');
        this._ = $injector.get('_');

        this.targetChangeAllowed = false;
        this.showChangeDaisyOrderContent = false;
        this.allowedTargets = false;

		this.init();
        this.registerEvents();
        this.initTransportauftrag(this.transportauftrag);
	}
	
	/**
	 * hide the dialog
	 **/
	hide() {
		this.$mdDialog.hide();
	}

	init() {
		this.showChangeDaisyOrderContent = false;
	}

	initTransportauftrag(transportAuftrag){
        this.transportauftrag = transportAuftrag;
        this.transportauftrag.momentDate = moment(this.transportauftrag.wunschtermin).toDate();
        this.transportauftrag.time = {
            hour: moment(this.transportauftrag.wunschtermin).get('hour'),
            minute: moment(this.transportauftrag.wunschtermin).get('minute')
        };
        this.transportauftrag.isDaisyOrder = this.DaisyValidationService.getIsDaisyOrder(this.transportauftrag);
        this.transportauftrag.positionen.forEach((position, index) => {
            position.posNr = index + 1;
            position.zuBuchendeMenge = position.menge;
            if (typeof position.mengeBereitsGebucht !== 'undefined'){
                position.zuBuchendeMenge = position.zuBuchendeMenge - position.mengeBereitsGebucht;
            }
            position.ziel = {
                id: this.transportauftrag.ziel.id,
                typ: this.transportauftrag.ziel.typ
            };
        });
        this.originalTransportauftrag = angular.copy(this.transportauftrag);
    }

    toggleShowChangeDaisyOrder(){
        this.targetChangeAllowed = false;
		if(this.transportauftrag.ziel.parentId !== 0){
            this.LocationService.getLocationTree(this.transportauftrag.ziel.parentId)
				.then((response) => {
                    this.targetChangeAllowed = true;
                    this.allowedTargets = response[0].positionen;
                    this.showChangeDaisyOrderContent = true;
				});
		}
        else if(this.transportauftrag.ziel.istLgrSystem === true){
            this.LocationService.getLocationTree(this.transportauftrag.ziel.id)
                .then((response) => {
                    this.targetChangeAllowed = true;
                    this.allowedTargets = response[0].positionen;
                    this.showChangeDaisyOrderContent = true;
                });
		}
		else{
            this.showChangeDaisyOrderContent = true;
		}
	}

    changeState(state){
        let newState = this.getConditionById(state);
        let transportAuftragToSave = angular.copy(this.originalTransportauftrag);
        transportAuftragToSave.status = newState;

        this.saveOrder(transportAuftragToSave);
	}

    registerEvents() {
        this.Socket.on('socket:transferOrder:changeOrder', (response) => {
            this.changeOrder(response.data[0]);
        });
        this.Socket.on('socket:transferOrder:deleteOrder', (response) => {
            this.changeOrder(response.data[0]);
        });
    }

    /**
     * change transfer order model with given order object
     * @param {Object} order - changed order object
     **/
    changeOrder(order) {
        if (order.id == this.transportauftrag.id){
            this.transportauftrag = order;
            this.transportauftrag.momentDate = moment(this.transportauftrag.wunschtermin).toDate();
            this.transportauftrag.time = {
                hour: moment(this.transportauftrag.wunschtermin).get('hour'),
                minute: moment(this.transportauftrag.wunschtermin).get('minute')
            };
            this.transportauftrag.isDaisyOrder = this.DaisyValidationService.getIsDaisyOrder(this.transportauftrag);
            this.originalTransportauftrag = angular.copy(this.transportauftrag);
        }
    }

    /**
     * save transfer order
     * @param {Object} order - order to save
     **/
    saveOrder(order) {
        order.verantwortlichePerson = {
            id: this.$session.auth.USER_ID,
            persNr: this.$session.auth.PERS_NR,
            fullname: this.$session.auth.FULLNAME
        };

        // Create request
        let request = this.TransferOrderService.createTransferOrderEditObject(order);
        order.positionen.forEach((position, index) => {
            const pos = {
                id: position.id,
                posNr: position.posNr,
                transportgutText: position.transportgutText,
                menge: parseInt(position.menge),
                mengeneinheitId: position.mengeneinheitId
            };
            request.positionen[index] = pos;
        });

        // Send transfer oder to the backened.
        this.TransferOrderService.editTransferOrder(request)
            .then((response) => {

            })
            .catch((err) => {
                //console.log('saveForm Error', err);
                // this.ToastService.danger(err.Text);
            });
    }

	onDeleteRestoreOrder(deleted = true) {
		const request = this.TransferOrderService.createTransferOrderDeleteObject(this.transportauftrag);
		request.geloescht = deleted;
		
		this.TransferOrderService.deleteTransferOrder(request)
			.then((response) => {
                this.showDeleteDialog = false;
			})
			.catch((err) => {
				this.ToastService.danger('Fehler beim '+statusText3+' des Auftrags. ' + err.statusText);
				this.hide();
			});
	}

	onTakeOverOrder() {
		this.transportauftrag.verantwortlichePerson = {
			id: this.$session.auth.USER_ID,
			persNr: this.$session.auth.PERS_NR,
			fullname: this.$session.auth.FULLNAME
		};

		this.saveForm();
	}

    /**
     * get condition by id
     * @param {int} id - id for condition
     * @return {Object} condition object with searched id
     **/
    getConditionById(status) {
        return this._.find(this.conditions, (condition) => {
            return status === condition.status;
        });
    }

    getLagerBestand(position){
    	let transportGut = position.transportgutObjekte[0];
        let bestand = false;
        if (typeof transportGut.lagerbestand !== 'undefined'){
            bestand = transportGut.lagerbestand;
        }
        return bestand;
	}

    getPositionsNummer(position){
        let transportGut = position.transportgutObjekte[0];
        let result = false;
        if (typeof transportGut.nr !== 'undefined'){
            result = transportGut.nr;
        }
        return result;
    }

    getPositionText(position){
    	let transportGut = position.transportgutObjekte[0];
    	let positionsText = transportGut.bez;
    	return positionsText;
	}

    bookOrder(){

        this.request = this.TransferOrderService.createTransferOrderBookObject(this.transportauftrag);
        this.transportauftrag.positionen.forEach((position, index) => {
            let mengeZuBuchen = parseInt(position.menge) - parseInt(position.mengeBereitsGebucht);

            this.request.positionen[index] = {
                id: position.id,
                posNr: position.posNr,
                menge: mengeZuBuchen,
                ziel: {
                    id: this.transportauftrag.ziel.id,
                    typ: this.transportauftrag.ziel.typ
                }
            };
        });

        // Send transfer oder to the backened.
        this.TransferOrderService.bookTransferOrder(this.request)
            .then((response) => {
            })
            .catch((err) => {
            });
	}

    bookOrderWithChange() {
        this.request = this.TransferOrderService.createTransferOrderBookObject(this.transportauftrag);
        this.transportauftrag.positionen.forEach((position, index) => {
            this.request.positionen[index] = {
                id: position.id,
                posNr: position.posNr,
                menge: parseInt(position.zuBuchendeMenge),
                ziel: {
                    id: this.transportauftrag.ziel.id,
                    typ: this.transportauftrag.ziel.typ
                }
            };

            if (
                typeof position.gewaehltesZiel !== 'undefined' &&
                typeof position.gewaehltesZiel.id !== 'undefined'
            )
            {
                this.request.positionen[index]['ziel'] = {
                    id: position.gewaehltesZiel.id,
                    typ: position.gewaehltesZiel.typ
                }
            }
        });

        // Send transfer oder to the backened.
        this.TransferOrderService.bookTransferOrder(this.request)
            .then((response) => {
            })
            .catch((err) => {
            });
    }

	/**
	 * query selected location
	 * @param  {object} query Location object
	 * @return {object}       Location object
	 */
	querySearchLocation(query) {
		return _.filter(this.locations, (obj) => {
			return (obj.bez.toLowerCase().indexOf(query.toLowerCase()) === 0);
		});
	}

    querySearchPositionTarget(query) {
	    if (typeof query == "undefined" || query == ''){
	        return this.allowedTargets;
        }
        return _.filter(this.allowedTargets, (obj) => {
            var includesBez = (obj.bez.toLowerCase().indexOf(query.toLowerCase()) === 0);
            var includesNr = (obj.nr.toLowerCase().indexOf(query.toLowerCase()) === 0);
            return includesBez || includesNr;
        });
    }

	querySearchUnit(query) {
		return _.filter(this.units, (obj) => {
			return (obj.bez.toLowerCase().indexOf(query.toLowerCase()) === 0);
		});
	}

	/*
	 * save transfer order
	 * @return {void} 
	 */
	saveForm() {
		// Manipulate Date
		let day = this.moment(this.transportauftrag.momentDate).get('date');
		let month = this.moment(this.transportauftrag.momentDate).get('month');
		let year = this.moment(this.transportauftrag.momentDate).get('year');
		let date = new Date(year, month, day, this.transportauftrag.time.hour, this.transportauftrag.time.minute);
		this.transportauftrag.wunschtermin = this.moment.parseZone(date).format();

		// Check if transfer order is delayed or in time.
		this.transportauftrag.isInTime = this.TimeService.isInTime(this.transportauftrag.wunschtermin, this.warningOffsetTime);
		this.transportauftrag.isDelayed = this.TimeService.isDelayed(this.transportauftrag.wunschtermin, this.dangerOffsetTime);

		// Manipulate target
		if(this.selectedItemTo && this.selectedItemTo.id !== this.transportauftrag.ziel.id) {
			this.transportauftrag.ziel = this.selectedItemTo;
		}

		// Create request
		this.request = this.TransferOrderService.createTransferOrderEditObject(this.transportauftrag);
		this.transportauftrag.positionen.forEach((position, index) => {
            this.request.positionen[index] = {
                id: position.id,
                posNr: position.posNr,
                transportgutText: position.transportgutText,
                menge: parseInt(position.menge),
                mengeneinheitId: position.mengeneinheitId
            };
		});

		// Send transfer oder to the backened.
		this.TransferOrderService.editTransferOrder(this.request)
			.then((response) => {
				// this.hide();
			})
			.catch((err) => {
				this.ToastService.danger('Fehler beim Speichern des Auftrags. ' + err.statusText);
			    //	this.hide();
			});
	}

    /**
     * static method to check if the user is authenticated
     * @param {function} - $injector to inject all services
     * @param {string} [path="Login"] - the path to navigate to if the user is not authenticated
     * @return {promise} with true/false
     **/
    static $canActivate($injector, path = 'Login') {
        const $rootRouter = $injector.get('$rootRouter');
        const AuthService = $injector.get('AuthService');
        const ToastService = $injector.get('ToastService');

        return AuthService.isAuthenticated().then((response) => {
            if (response) {
                return response;
            }
            $rootRouter.navigate([path]);
            ToastService.danger('Zugriff verweigert. Bitte melden Sie sich an.');
            return false;
        }, (err) =>  {
            $rootRouter.navigate([path]);
            return false;
        });
    }

}
